import React, { useState } from "react";

const DatePicker = ({ from, to, setFrom, setTo}) => {
  const [isDatePickerVisible, setIsDatePickerVisible] = useState(false);
  const [tempFrom, setTempFrom] = useState("");
  const [tempTo, setTempTo] = useState("");

  const handleDatePickerClick = () => {
    setIsDatePickerVisible(true);
  };

  const handleDateChange = (e, type) => {
    const selectedDate = e.target.value;
    if (type === "from") {
      setTempFrom(selectedDate);
    } else if (type === "to") {
      setTempTo(selectedDate);
    }
  };

  const handleSaveDates = () => {
    if (!tempFrom || !tempTo) {
      alert("From과 To 날짜를 모두 선택하세요.");
      return;
    }

    if (new Date(tempFrom) > new Date(tempTo)) {
      alert("From 날짜는 To 날짜보다 이전이어야 합니다.");
      return;
    }

    setFrom(tempFrom);
    setTo(tempTo);
    setIsDatePickerVisible(false);
  };

  return (
    <div>
      <button id="datePickerBtn" onClick={handleDatePickerClick}>
        날짜 선택
      </button>
      <h3>From {from} to {to}</h3>
      {isDatePickerVisible && (
        <div className="selectDate">
          <div>
            <label htmlFor="fromDatePicker">From: </label>
            <input
              type="date"
              id="fromDatePicker"
              onChange={(e) => handleDateChange(e, "from")}
            />
          </div>
          <div>
            <label htmlFor="toDatePicker">To: </label>
            <input
              type="date"
              id="toDatePicker"
              onChange={(e) => handleDateChange(e, "to")}
            />
          </div>
          <button onClick={handleSaveDates}>완료</button>
        </div>
      )}
    </div>
  );
};

export default DatePicker;
